import VueRouter from 'vue-router'
import Login from './pages/Login.vue'
import Workers from './pages/Workers.vue'
import WorkerDetail from './pages/WorkerDetail.vue'
import Users from './pages/users/Users.vue'
import UserDetail from './pages/users/UserDetail.vue'
import DocTemplates from './pages/DocTemplates.vue'
import DocTemplateDetail from './pages/DocTemplateDetail.vue'
import Employers from './pages/Employers.vue'
import EmployerDetail from './pages/EmployerDetails.vue'
import Landlords from './pages/Landlords.vue'
import LandlordDetail from './pages/LandlordDetail.vue'
import HistoryPage from './pages/History.vue'
import Reports from './pages/reports/Reports.vue'
import Settings from './pages/settings/Settings.vue'
import Agencies from './pages/Agency'
import AgencyDetail from './pages/agency/AgencyDetail'
import PersonalFinance from './pages/personalFinance/PersonalFinance'
import Page404 from './pages/Page404.vue'

import auth from './utils/AuthUtil'

export default new VueRouter({
	mode: 'history',
	linkActiveClass: 'active',
	routes: [
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: {
				title: 'login'
			}
		},
		{
			path: '/users',
			name: 'users',
			component: Users,
			beforeEnter: auth.hasRole('admin'),
			meta: {
				title: 'users'
			}
		},
		{
			path: '/users/:userId',
			name: 'userDetail',
			component: UserDetail,
			beforeEnter: auth.hasRole('admin'),
			meta: {
				title: 'user'
			}
		},
		{
			path: '/workers',
			name: 'workers',
			component: Workers,
			beforeEnter: auth.hasRole('admin', 'canPrepay', 'manager'),
			meta: {
				title: 'workers'
			}
		},
		{
			path: '/workers/:workerId',
			name: 'workerDetailDetail',
			component: WorkerDetail,
			beforeEnter: auth.hasRole('admin', 'canPrepay', 'manager'),
			meta: {
				title: 'worker'
			}
		},
		{
			path: '/employers',
			name: 'employers',
			component: Employers,
			beforeEnter: auth.hasRole('admin', 'manager'),
			meta: {
				title: 'employers'
			}
		},
		{
			path: '/employers/:employerId',
			name: 'employerDetail',
			component: EmployerDetail,
			beforeEnter: auth.hasRole('admin', 'manager'),
			meta: {
				title: 'employer'
			}
		},
		{
			path: '/landlords',
			name: 'landlords',
			component: Landlords,
			beforeEnter: auth.hasRole('admin', 'manager'),
			meta: {
				title: 'landlords'
			}
		},
		{
			path: '/landlords/:landlordId',
			name: 'landlordDetail',
			component: LandlordDetail,
			beforeEnter: auth.hasRole('admin', 'manager'),
			meta: {
				title: 'landlord'
			}
		},
		{
			path: '/reports',
			name: 'reports',
			component: Reports,
			beforeEnter: auth.hasRole('admin'),
			meta: {
				title: 'finance_reports'
			}
		},
		{
			path: '/history',
			name: 'history',
			component: HistoryPage,
			beforeEnter: auth.hasRole('admin'),
			meta: {
				title: 'history'
			}
		},
		{
			path: '/templates',
			name: 'templates',
			component: DocTemplates,
			beforeEnter: auth.hasRole('admin', 'manager'),
			meta: {
				title: 'templates'
			}
		},
		{
			path: '/templates/:templateId',
			name: 'templateDetail',
			component: DocTemplateDetail,
			beforeEnter: auth.hasRole('admin', 'manager'),
			meta: {
				title: 'template'
			}
		},
		{
			path: '/agencies',
			name: 'agency',
			component: Agencies,
			beforeEnter: auth.hasRole('admin', 'manager'),
			meta: {
				title: 'agencies'
			}
		},
		{
			path: '/agencies/:agencyId',
			name: 'agencyDetail',
			component: AgencyDetail,
			beforeEnter: auth.hasRole('admin', 'manager'),
			meta: {
				title: 'agency'
			}
		},
		{
			path: '/personal-finance',
			name: 'personalFinance',
			component: PersonalFinance,
			beforeEnter: auth.hasRole('admin', 'canPrepay', 'manager'),
			meta: {
				title: 'personal_finance'
			}
		},
		{
			path: '/personal-finance/user/:userId',
			name: 'userPersonalFinance',
			component: PersonalFinance,
			beforeEnter: auth.hasRole('admin'),
			meta: {
				title: 'personal_finance'
			}
		},
		{
			path: '/settings',
			name: 'settings',
			component: Settings,
			beforeEnter: auth.hasRole('admin'),
			meta: {
				title: 'settings'
			}
		},
		{
			path: '*',
			beforeEnter: (to, from, next) => {
				next("/login")
			}
		}
	]
})
